import { Grid } from '@mui/material';
import { CheckboxItem } from 'lib/designSystem/CheckBoxItem';
import React from 'react';

import {
  ExportCheckboxesSetters,
  ExportCheckboxesState,
} from '../hooks/useExportCheckboxes';
import { CheckboxWithButton } from './CheckboxWithButton';

interface ExportCheckboxesProps {
  checkboxes: ExportCheckboxesState;
  setters: ExportCheckboxesSetters;
  selectedRequest: any;
  canShowPayouts?: boolean;
  includeRateComposition?: boolean;
  includePayouts?: boolean;
  onChatButtonClick?: () => void;
  onChatAsObservationsChange?: (checked: boolean) => void;
  isChatButtonDisabled?: boolean;
}

export const ExportCheckboxes: React.FC<ExportCheckboxesProps> = ({
  checkboxes,
  setters,
  selectedRequest,
  canShowPayouts = false,
  includeRateComposition = false,
  includePayouts = false,
  onChatButtonClick,
  onChatAsObservationsChange,
  isChatButtonDisabled = false,
}) => {
  const {
    showAdvance,
    showRate,
    showRateComposition,
    showArrearRate,
    showAmount,
    showAmountAdvance,
    showAmountRetained,
    showAmountDifference,
    showAmountComissionIva,
    showAmountTotalApplied,
    showDraftBalance,
    showExpenses,
    showGuaranteeAmount,
    showPayouts,
    showExecutiveNameAsUser,
    showExpensesDetails,
    showDueDate,
    showDays,
    showChatAsObservations,
    showFundRate,
    showSpread,
    selectedChatMessages,
  } = checkboxes;

  const {
    setShowAdvance,
    setShowRate,
    setShowRateComposition,
    setShowArrearRate,
    setShowAmount,
    setShowAmountAdvance,
    setShowAmountRetained,
    setShowAmountDifference,
    setShowAmountComissionIva,
    setShowAmountTotalApplied,
    setShowDraftBalance,
    setShowExpenses,
    setShowGuaranteeAmount,
    setShowPayouts,
    setShowExecutiveNameAsUser,
    setShowExpensesDetails,
    setShowDueDate,
    setShowDays,
    setShowChatAsObservations,
    setShowFundRate,
    setShowSpread,
  } = setters;

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <CheckboxItem
          label="Mostrar avance"
          checked={showAdvance}
          onChange={setShowAdvance}
        />
        <CheckboxItem
          label="Mostrar tasa de negocio"
          checked={showRate}
          onChange={setShowRate}
        />
        {includeRateComposition && (
          <CheckboxItem
            label="Ver composición de la tasa"
            checked={showRateComposition}
            onChange={setShowRateComposition}
          />
        )}
        <CheckboxItem
          label="Mostrar tasa del fondo"
          checked={showFundRate}
          onChange={setShowFundRate}
        />
        <CheckboxItem
          label="Mostrar spread"
          checked={showSpread}
          onChange={setShowSpread}
        />
        <CheckboxItem
          label="Mostrar tasa de mora"
          checked={showArrearRate}
          onChange={setShowArrearRate}
        />
        <CheckboxItem
          label="Mostrar monto total"
          checked={showAmount}
          onChange={setShowAmount}
        />
        <CheckboxItem
          label="Mostrar monto anticipado"
          checked={showAmountAdvance}
          onChange={setShowAmountAdvance}
        />
        <CheckboxItem
          label="Mostrar monto retenido"
          checked={showAmountRetained}
          onChange={setShowAmountRetained}
        />
        <CheckboxItem
          label="Mostrar fecha vencimiento"
          checked={showDueDate}
          onChange={setShowDueDate}
        />
        {includePayouts && canShowPayouts && (
          <CheckboxItem
            label="Incluir pagos realizados"
            checked={showPayouts}
            onChange={setShowPayouts}
          />
        )}
        <CheckboxItem
          label="Mostrar desglose de gastos"
          checked={showExpensesDetails}
          onChange={setShowExpensesDetails}
        />
      </Grid>
      <Grid item xs={6}>
        <CheckboxItem
          label="Mostrar diferencia de precio"
          checked={showAmountDifference}
          onChange={setShowAmountDifference}
        />
        <CheckboxItem
          label="Mostrar monto comisión + IVA"
          checked={showAmountComissionIva}
          onChange={setShowAmountComissionIva}
        />
        <CheckboxItem
          label={`Mostrar monto gastos ${
            selectedRequest.expensesIVA ? '+ IVA' : ''
          }`}
          checked={showExpenses}
          onChange={setShowExpenses}
        />
        <CheckboxItem
          label="Mostrar monto total aplicado"
          checked={showAmountTotalApplied}
          onChange={setShowAmountTotalApplied}
        />
        <CheckboxItem
          label="Mostrar monto saldo giro"
          checked={showDraftBalance}
          onChange={setShowDraftBalance}
        />
        <CheckboxItem
          label="Mostrar monto en garantía"
          checked={showGuaranteeAmount}
          onChange={setShowGuaranteeAmount}
        />
        <CheckboxItem
          label="Mostrar ejecutivo en campo usuario"
          checked={showExecutiveNameAsUser}
          onChange={setShowExecutiveNameAsUser}
        />
        <CheckboxItem
          label="Mostrar días"
          checked={showDays}
          onChange={setShowDays}
        />
        <CheckboxWithButton
          label="Chat como observaciones"
          checked={showChatAsObservations}
          onChange={onChatAsObservationsChange || setShowChatAsObservations}
          chipCount={selectedChatMessages.length}
          onButtonClick={onChatButtonClick || (() => {})}
          buttonDisabled={isChatButtonDisabled}
        />
      </Grid>
    </Grid>
  );
};
